<footer class="bg-dark text-light mt-5 py-4">
  <div class="container text-center">
    <!-- Links -->
    <ul class="list-inline mb-3">
      <li class="list-inline-item">
        <a href="/about" class="text-decoration-none text-light">About</a>
      </li>
      <li class="list-inline-item">
        <a href="/rules" class="text-decoration-none text-light">Rules</a>
      </li>
      <li class="list-inline-item">
        <a href="/contact" class="text-decoration-none text-light">Contact</a>
      </li>
    </ul>

    <!-- Social media -->
    <div class="mb-3">
      <a href="https://facebook.com" target="_blank" class="text-light me-3">
        <i class="fa-brands fa-facebook fa-lg"></i>
      </a>
      <a href="https://instagram.com" target="_blank" class="text-light me-3">
        <i class="fa-brands fa-instagram fa-lg"></i>
      </a>
      <a href="https://tiktok.com" target="_blank" class="text-light">
        <i class="fa-brands fa-tiktok fa-lg"></i>
      </a>
    </div>

    <!-- Copyright -->
    <p class="mb-0 small">&copy; {{ currentYear }} NBHA. All rights reserved.</p>
  </div>
</footer>
